
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planning-archive/[[...page]]",
      function () {
        return require("private-next-pages/planning-archive/[[...page]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planning-archive/[[...page]]"])
      });
    }
  